export default {
  default: () => import("/Users/lucaperusi/Documents/MARS/code/mars-website-nuxt/layouts/default.vue").then(m => m.default || m),
  none: () => import("/Users/lucaperusi/Documents/MARS/code/mars-website-nuxt/layouts/none.vue").then(m => m.default || m)
}